module.exports = __webpack_public_path__ + "static/media/logo-footer.42e839a5.png";